import React from 'react';
import AccountSettingsHeader from './account-settings-header';
import ChangingYourPassword from './changing-your-password';
import YourEmailAddress from './your-email-address';

const AccountSettingsComponent = () => {
  return (
    <div className="govuk-width-container">
      <AccountSettingsHeader />
      <ChangingYourPassword />
      <YourEmailAddress />
    </div>
  );
};

export default AccountSettingsComponent;
